export default __webpack_public_path__ + "static/media/Tissues-Wipes.ace6db2c.jpg";